import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import Hero from './components/Hero';
import Positioning from './components/Positioning';
import Relationship from './components/Relationship';
import Capabilities from './components/Capabilities';
import Qualifications from './components/Qualifications';
import Ecosystem from './components/Ecosystem';

export default function About() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="华辉数智，九畴云市的技术交付与系统实现方"
        description="华辉数智技术是面向县域与乡村场景的人工智能应用服务与数字商业基础设施服务商，承担九畴云市核心技术研发、系统交付与产业数字化建设。"
        keywords="华辉数智技术,人工智能应用服务商,数字商业基础设施,乡村数字经济,九畴云市"
        path="/about/company"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: '华辉数智技术',
          alternateName: 'HUAHUI DIGITAL INTELLIGENCE',
          description: '面向县域与乡村场景的人工智能应用服务与数字商业基础设施服务商。',
          areaServed: '中国',
          knowsAbout: ['人工智能应用服务', '乡村数字经济', '县域数字商业基础设施'],
        }}
      />
      <main>
        <Hero />
        <Breadcrumb items={[{ label: '关于我们' }, { label: '公司' }]} />
        <Positioning />
        <Relationship />
        <Capabilities />
        <Qualifications />
        <Ecosystem />
      </main>
      <Footer />
    </div>
  );
}